/** TanStack Query keys, one place so Realtime invalidation and hooks agree. */
export const queryKeys = {
  members: ['members'] as const,
  memberForUser: (userId: string) => ['members', 'by-user', userId] as const,
  games: ['games'] as const,
  tasks: ['tasks'] as const,
  gameTasks: (gameId: string) => ['tasks', 'game', gameId] as const,
  labels: ['labels'] as const,
  comments: ['comments'] as const,
  taskComments: (taskId: string) => ['comments', taskId] as const,
  activity: ['activity'] as const,
  taskActivity: (taskId: string) => ['activity', 'task', taskId] as const,
  ideas: ['ideas'] as const,
  ideaLinks: ['links', 'ideas'] as const,
  ideaVotes: ['idea_votes'] as const,
  docs: ['docs'] as const,
  ownerDocs: (ideaId: string, gameId: string | null) => ['docs', 'owner', ideaId, gameId] as const,
  doc: (docId: string) => ['docs', 'one', docId] as const,
  docVersions: ['doc_versions'] as const,
  versionsOf: (docId: string) => ['doc_versions', docId] as const,
  templates: ['doc_templates'] as const,
  vaultLinks: ['vault_links'] as const,
  files: ['files'] as const,
  links: ['links'] as const,
  itemLinks: (type: string, id: string) => ['links', 'item', type, id] as const,
  googleAccount: ['google_account'] as const,
  studioSettings: ['studio_settings'] as const,
  sprints: ['sprints'] as const,
  gameSprints: (gameId: string) => ['sprints', 'game', gameId] as const,
  sprintStats: ['sprint_stats'] as const,
  burndown: (sprintId: string) => ['sprint_stats', 'burndown', sprintId] as const,
  velocity: (gameId: string) => ['sprint_stats', 'velocity', gameId] as const,
  dependencies: ['task_dependencies'] as const,
  gameDependencies: (gameId: string) => ['task_dependencies', 'game', gameId] as const,
  savedViews: (module: string) => ['saved_views', module] as const,
  channels: ['channels'] as const,
  messages: ['messages'] as const,
  channelMessages: (channelId: string) => ['messages', 'channel', channelId] as const,
  thread: (rootId: string) => ['messages', 'thread', rootId] as const,
  allReactions: ['message_reactions'] as const,
  reactions: (channelId: string) => ['message_reactions', channelId] as const,
  attachments: ['links', 'attachments'] as const,
  channelSettings: ['channel_members'] as const,
  unread: ['channel_unread'] as const,
};
